// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__YsSvu","logo":"style_logo__Xfmjz","chip":"style_chip__JR9-9","spinner":"style_spinner__Dp9P0"};